import { Box, CardContent } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm/LoginForm";
import { useSelector } from "react-redux";
import { useEffect /* useState */ } from "react";
import { ROLE, SUB_ROLE } from "../../../utils/constants/profiles";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { generateDynamicProtectedRoutes } from "../../../routes/protectedRoutes/generateDynamicProtectedRoutes";

const LoginPage = () => {
  const { t } = useTranslation();
  const isAuth = useSelector((state) => {
    return Boolean(state.app.accessToken);
  });
  const role = useSelector((state) => {
    return state.app.role;
  });
  const subRole = useSelector((state) => {
    return state.app.subRole;
  });
  const appConfig = useSelector((state) => state.app.appConfig);

  const getCorrectRoute = () => {
    const routes = generateDynamicProtectedRoutes(role, appConfig);
    return routes.find((e) => e.name === appConfig?.mainSection)?.path;
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (isAuth && appConfig) {
      setTimeout(() => {
        if (ROLE.BUSINESS === role) {
          if (SUB_ROLE.OPERATOR === subRole)
            navigate(`/auth/operator/${getCorrectRoute()}`);
          else navigate(`/auth/business/${getCorrectRoute()}`);
        } else if (ROLE.USER === role) {
          navigate(`/auth/user/${getCorrectRoute()}`);
        } else if (ROLE.ADMIN === role) {
          navigate(`/auth/admin/${getCorrectRoute()}`);
        } else {
          console.error(
            "isAuth è true, ma non sei stato redirezionato! ruolo sconosciuto"
          );
        }
      }, 500);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth, appConfig]);

  return (
    <CardContent className="py-12 px-24">
      <MainSection />
    </CardContent>
  );
};

const MainSection = () => {
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const appConfig = useSelector((state) => state.app.appConfig);
  return (
    <>
      <Box className="flex flex-col items-center mt-5">
        <img src={appConfig?.assets?.imgs?.login} alt="logo" className="h-24" />
        <h3 style={{ color: primaryColor }} className="text-center">
          {t("LoginSentence")}
        </h3>
      </Box>

      <LoginForm />

      <p className="text-center mt-8">
        {t("ForgotPassword")}
        <Link to="/forgot-password">
          <span className="font-bold"> {t("RecoverPassword")} </span>
        </Link>
      </p>
    </>
  );
};

export default LoginPage;
